import React from 'react';
import './topbar-nav.less';

/**
 * 通用顶部导航
 *  title  title，可以不写
 *  children 孩子，配置右上角的工具
 *  leftTool 左侧工具的功能 ，可选项是  back ， close  null  不显示
 *  onBack 返回操作
 *  onClose 关闭操作
 *  {*}
 * @constructor
 */
export default function TopbarNav(props) {
    const {
        title,
        children,
        bordered = false,
        leftTool = 'back',
        onBack = () => {
            window.history.back();
        },
        onClose = () => {
        }
    } = props;
    let leftToolComp = <div className="topbar-back" onClick={onBack}/>;

    if (UG.isUplive) {
        leftToolComp =
            <div className="topbar-back" data-show="uplive" onClick={onBack}>{UG.lang.template('Previous page')}</div>;
    }

    if (leftTool === 'close') {
        leftToolComp = <div className="topbar-close" onClick={onClose}/>;
    }
    if (leftTool === 'null') {
        leftToolComp = <div className="topbar-tool-null"/>;
    }

    return (
        <div className={bordered ? 'topbar-nav bordered' : 'topbar-nav'}>
            {leftToolComp}
            <div className="topbar-title text-center">
                {UG.isUplive ? null : title}
            </div>
            <div className="topbar-tool">
                {children}
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/host/common/topbar-nav.js